import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SchedeIntenseListConfig, WMAIApiService } from '../../core';
import { SchedaIntense } from '../../core/models';
import { Status } from '../../core/models/status.model';
import { TranslateService } from '@ngx-translate/core';
import { WgisService } from '../../wgis/wgis.service';
import { WGisDisplayMode } from '../../wgis/wgis.utils';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-schedaintense-list',
  templateUrl: './schedaintense-list.component.html'
})
export class SchedaintenseListComponent implements OnInit, OnDestroy {

  isMapVisible: boolean = false;
  isSmallScreen: boolean = false;

  languageSubscription: Subscription;
  
  constructor(
    private wmaiservice: WMAIApiService,
    private wgisservice: WgisService,
    private breakpointObserver: BreakpointObserver,
    private translateService: TranslateService
  ) {
    this.wgisservice.wgisVisible.subscribe((mode: WGisDisplayMode) => {
      this.isMapVisible = (mode !== WGisDisplayMode.Invisible);
    });
    this.isSmallScreen = breakpointObserver.isMatched('(max-width: 768px)');
    this.subscribeLanguage();
  }

  @Input() limit: number;
  @Input()
  set config(config: SchedeIntenseListConfig) {
    if (config) {
      this.query = config;
      this.currentPage = 1;
      this.getListaSchedeIntense();
    }
  }

  query: SchedeIntenseListConfig;
  resultsCount: number = 0;
  loading = false;
  currentPage = 1;
  pageSize = 6;
  maxSize = 5;
  ellipses = true;
  totalPages: Array<number> = [1];
  results: SchedaIntense[] = [];
  errormsg: Status[] = [];

  selectedPage: number;

  setPageTo(pagenumber) {
    this.currentPage = pagenumber;
    this.results = [];
    this.getListaSchedeIntense();
  }

  ngOnInit() {
    this.isSmallScreen = this.breakpointObserver.isMatched('(max-width: 768px)');
  }

  ngOnDestroy(){
    this.languageSubscription.unsubscribe();
  }

  subscribeLanguage(){
    this.languageSubscription = this.translateService.onLangChange.subscribe(() => {
      this.results = [];
      this.currentPage = 1;
      this.getListaSchedeIntense();
    })
  }
  /**
   * si richiede la lista delle schede intense e si verifica qunte pagine sono
   */
  getListaSchedeIntense() {

    if (this.limit) {
      this.query.filters.last_modified_since = 1296000;
      this.query.filters.pageNumber = this.currentPage;
      this.query.filters.pageSize = 6;
      this.query.filters.order = "desc";
      this.query.filters.orderby = "changed";
      this.query.filters.locale = this.translateService.getDefaultLang();
    }

    this.wmaiservice.queryLatestSchede(this.query).subscribe(
      data => {
        if (data != null) {
          this.results = data['data'];
          //this.wgisservice.showSchedeIntense(this.results);
          this.loading = false;
          if (this.results != null) {
            this.resultsCount = data['metadata']['rowCount'];

            let tmp = Math.ceil(this.resultsCount / this.limit) + 1;
            this.totalPages = this.resultsCount <= 6 ? this.totalPages : Array.from(new Array<number>(tmp).keys()).map(x => ++x);
          }
        }
      });
  }

  displaymap() {
    this.wgisservice.cmdToggleMap();
    this.isMapVisible = this.wgisservice.getMapVisible();
  }
}
